import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
/* 公共页面 */
import layOut from '@/components/layOut';
const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/loginIndex"),
  },
  {
    path: "/",
    component: layOut,
    redirect: "/login", //空路由默认指向登陆页
    children: [
      {
        path: "index",
        component: () => import("@/views/index/userIndex.vue"),
        meta: {
          activePath: "/index",
        },
      },
      {
        path: "publicOpinion",
        component: () => import("@/views/publicOpinion/publicOpinion.vue"),
        meta: {
          activePath: "/publicOpinion",
          name: "舆情发现"
        },
      },
      {
        path: "publicOpinionDetails",
        component: () => import("@/views/publicOpinion/publicOpinionDetails.vue"),
        meta: {
          activePath: "/publicOpinion",
          name: "上报详情",
          parentPath: [{ name: "舆情发现", path: "/publicOpinion" }]
        },
      },
      {
        path: "judgeRecords",
        component: () => import("@/views/publicOpinion/judgeRecords.vue"),
        meta: {
          activePath: "/publicOpinion",
          name: "研判记录",
          parentPath: [{ name: "舆情发现", path: "/publicOpinion" }]
        },
      },
      {
        path: "sentinelUser",
        component: () => import("@/views/sentinelUser/sentinelUser.vue"),
        meta: {
          activePath: "/sentinelUser",
          name: "上报人员",
        },
      },
      {
        path: "inspectWork",
        component: () => import("@/views/sentinelUser/inspectWork.vue"),
        meta: {
          activePath: "/sentinelUser",
          name: "工作情况",
          parentPath: [{ name: "上报人员", path: "/sentinelUser" }]
        },
      },
      {
        path: "codeControl",
        component: () => import("@/views/sentinelUser/codeControl.vue"),
        meta: {
          activePath: "/sentinelUser",
          name: "激活码管理",
          parentPath: [{ name: "上报人员", path: "/sentinelUser" }]
        },
      },
      {
        path: "codeControlDetails",
        component: () => import("@/views/sentinelUser/codeControlDetails.vue"),
        meta: {
          activePath: "/sentinelUser",
          name: "详情",
          parentPath: [{ name: "上报人员", path: "/sentinelUser" },{ name: "激活码管理", path: "/codeControl" }]
        },
      },
      {
        path: "institutionIndex",
        component: () => import("@/views/institution/institutionIndex.vue"),
        meta: {
          activePath: "/institutionIndex",
          name: "机构管理",
        },
      },
      {
        path: "examineStatistics",
        component: () => import("@/views/examineStatistics/examineStatistics.vue"),
        meta: {
          activePath: "/examineStatistics",
          name: "考核统计",
        },
      },
      {
        path: "institutionStatistics",
        component: () => import("@/views/institutionStatistics/institutionStatistics.vue"),
        meta: {
          activePath: "/institutionStatistics",
          name: "机构考核统计",
        },
      },
      {
        path: "areaStatistics",
        component: () => import("@/views/areaStatistics/areaStatistics.vue"),
        meta: {
          activePath: "/areaStatistics",
          name: "区域考核统计",
        },
      },
      {
        path: "userStatistics",
        component: () => import("@/views/userStatistics/userStatistics.vue"),
        meta: {
          activePath: "/userStatistics",
          name: "人员考核统计",
        },
      },
      {
        path: "basicInformation",
        component: () => import("@/views/basicInformation/basicInformation.vue"),
        meta: {
          activePath: "/basicInformation",
          name: "基本信息",
        },
      },
    ]
  },
]
/* 路由跳转时 */
const router = createRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  history: createWebHashHistory(),
  routes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 在每次路由跳转前获取sessionStorage内容
  const user = sessionStorage.getItem('user');

  // 根据需要处理获取到的数据
  if (user) {
    // 做一些基于someData的逻辑处理
    // 必须调用next()来resolve这个钩子
    next();
    
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next('/login');
      ElMessage.warning('登录已失效,请重新登录')
      sessionStorage.clear();
    }
  }

  
});
export default router
